export default __webpack_public_path__ + "static/media/GTSectra-Regular_3.8470c81fe4561daf4f1e.8470c81f.woff2";